<login-home-navigation></login-home-navigation>
<section class="vendor-proof-section">

    <div class="container">

        <div class="section-header">

            <span class="section-badge">
                Success Stories
            </span>

            <h2>
                Manufacturing Companies Growing Through GYV
            </h2>

            <p>
                Suppliers across machining, casting, forging, fabrication and
                industrial manufacturing use GYV to connect with buyers and
                discover new business opportunities.
            </p>

        </div>

        <div class="proof-gallery">

            <img src="assets/images/media/home/customerwins/2.webp">
            <img src="assets/images/media/home/customerwins/5.webp">
            <img src="assets/images/media/home/customerwins/8.webp">
            <img src="assets/images/media/home/customerwins/14.webp">
            <img src="assets/images/media/home/customerwins/22.webp">
            <img src="assets/images/media/home/customerwins/27.webp">

        </div>

    </div>

</section>

<!-- NETWORK NUMBERS -->

<section class="vendor-network">

    <div class="container">

        <div class="row">

            <div class="col-lg-3 col-6">

                <div class="network-card">
                    <h3>300+</h3>
                    <p>Active Buyers</p>
                </div>

            </div>

            <div class="col-lg-3 col-6">

                <div class="network-card">
                    <h3>16,000+</h3>
                    <p>Suppliers</p>
                </div>

            </div>

            <div class="col-lg-3 col-6">

                <div class="network-card">
                    <h3>3,000+</h3>
                    <p>Business Matches</p>
                </div>

            </div>

            <div class="col-lg-3 col-6">

                <div class="network-card">
                    <h3>40+</h3>
                    <p>Manufacturing Categories</p>
                </div>

            </div>

        </div>

    </div>

</section>

<!-- ROI SECTION -->

<section class="vendor-roi">

    <div class="container">

        <div class="section-header">

            <h2>
                Focus On Manufacturing, Not Prospecting
            </h2>

        </div>

        <div class="row">

            <div class="col-lg-4">

                <div class="roi-card">

                    <h4>Reduce Sales Costs</h4>

                    <p>
                        Minimize travel, exhibitions, cold calling and
                        customer acquisition expenses.
                    </p>

                </div>

            </div>

            <div class="col-lg-4">

                <div class="roi-card">

                    <h4>Access Buyers Faster</h4>

                    <p>
                        Connect with procurement and sourcing teams
                        actively searching for suppliers.
                    </p>

                </div>

            </div>

            <div class="col-lg-4">

                <div class="roi-card">

                    <h4>Generate New Opportunities</h4>

                    <p>
                        Expand your customer base beyond referrals and
                        existing relationships.
                    </p>

                </div>

            </div>

        </div>

    </div>

</section>

<!-- CTA -->

<section class="vendor-cta">

    <div class="container">

        <h2>
            Ready To Connect With More Buyers?
        </h2>

        <p>
            Join India's growing manufacturing supplier network and
            showcase your capabilities to procurement teams.
        </p>

        <button class="vendor-btn" (click)="signup()">
            Register Your Company
        </button>

    </div>

</section>
<login-home-footer></login-home-footer>